<template>
    <transition name="modal-fade" v-if="isVisible">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop >
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>
                
                    <div class="col-12 title">{{title}}</div>
                     
                   
                    <div v-for="project in Projects" :key="project.Id" class="box" style="width:100%; padding: 4px 8px; display:flex; align-items:center; background: #f1f2f6;">
                        <div style="flex: 1;">
                            <div class="bold">{{project.Name}}</div>
                            <div class="info" v-if="project.IsOwner">{{project.Comments?.length > 30 ? project.Comments.substring(0, 30) + '...': project.Comments}}</div>

                        </div>
                        <div v-if="project.Subcontractors && project.Subcontractors.some(item => item.Id === sub.Id)" style="font-size:12px; width:150px; text-align: center; align-self:center;">
                            Added to Project
                        </div>
                        <div v-else>
                            <div class="btn btn-add-sub-to-project" style="font-size: 10px; height:30px; line-height:30px; margin:8px 0;" @click="addToProject(project)"></div>
                        </div>
                    </div>
 
                  
            </div>
            
        </div>
    </transition>

</template>

<script>
    export default {

        props: {
            visible: Boolean,
          
            subContractor: Object
            
        },

        data() {
            return {
                Projects:  [],
                title: "My Projects",
                isVisible: this.visible, // Local visibility state
                sub: {},
            }
        },
        mounted() {
            this.$core.GetProjectList(this.$core.data.UserInfo.Id).then((res) => {

                if (res?.Type == 200) {
                    this.$core.data.Projects = res.Data;
                    this.Projects = res.Data.filter(m=>m.Status == 0);

                    
                    console.log("ProjectList", this.Projects);
                }


            });
        },
        watch: {
            visible(newVal) {
                this.isVisible = newVal; // Sync local state with prop changes

                this.sub = this.subContractor;
            },
        },
        methods: {
            addToProject(project) {

                //console.log("addToProject", project);
                //console.log("addToProject", this.sub);

                this.sub.ProjectId = project.Id;
                this.$emit('addToProject', this.sub);
            },
      
            save() {
                 
                if (!this.PersonalInfo.FirstName) {
                    this.$emit('alert', 'First Name Field is mandatory');
                    return;
                }
                if (!this.PersonalInfo.LastName) {
                    this.$emit('alert', 'Last Name Field is mandatory');
                    return;
                }
                if (!this.PersonalInfo.Phone) {
                    this.$emit('alert', 'Phone Number Field is mandatory');
                    return;
                }
                if (!this.PersonalInfo.Email) {
                    this.$emit('alert', 'Email Field is mandatory');
                    return;
                }

                this.$emit('saveProfile', this.PersonalInfo);
            }

        }
    }
</script>

<style scoped>

    .box{
        border: 1px solid #ccc;
        border-radius: 8px;
        margin-bottom: 8px;
        padding: 8px;
        position: relative;
        background: #f1f2f6;
    }
    .modal-overlay {
        z-index:999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
        max-width:100%;
    }

    .modal-content {
        background-color: white;
        height: fit-content;
        width: 500px;
        max-width: 90vh;
        max-height: 90vh;
        margin:auto;
        padding: 0px 24px;
        border-radius: 20px;
       
    }


   

    .check {
        width: 150px;
    }

   
    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .form-check-inline {
        margin: 4px 0px;
    }

    .form-check-label {
        vertical-align: middle;
    }

    .form-check-input {
        vertical-align: middle;
    }
</style>